import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Spin, Row, Button, DatePicker, InputNumber } from "antd";
import moment from "moment";
import "./index.scss";
import Table1 from "./Table1";
import Table2 from "./Table2";
import Table3 from "./Table3";
import Table4 from "./Table4";
import Table5 from "./Table5";
import { runInAction } from "mobx";
import Auth from "@/components/table/Auth";
const { WeekPicker } = DatePicker;

@inject("store")
@observer
class App extends Component {
  componentDidMount() {
    this.props.store.kpifollow.getData(this.props.store.kpifollow.date);
  }

  render() {
    const { loading, date, getData, onSave, room, saving } =
      this.props.store.kpifollow;

    return (
      <Spin spinning={loading}>
        <div className="table7_1_1 kpifollow">
          <Row className="title" id="table11">
            <Row>KPI Follow参数</Row>
            <Row className="table-month">
              <WeekPicker
                placeholder="请选择日期"
                style={{ width: 150 }}
                value={moment(date, "YYYY-W")}
                format={"YYYY-W"}
                onChange={(str, r) => {
                  getData(r);
                }}
              ></WeekPicker>
              <span className="note">
                酒店房间总数:
                <InputNumber
                  value={room}
                  style={{ width: 200, marginLeft: 10 }}
                  min={0}
                  onChange={(e) => {
                    runInAction(() => {
                      this.props.store.kpifollow.room = e;
                    });
                  }}
                />
              </span>
            </Row>
            <Table1 />
            <Table2 />
            <Table3 />
            <Table4 />
            <Table5 />
            <Auth loading={loading} auth="edit_kpifollow">
              <Button
                className="footer-btn"
                type="primary"
                onClick={onSave}
                loading={saving}
              >
                保存
              </Button>
            </Auth>
          </Row>
        </div>
      </Spin>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/kpifollow/index.js